import { Button, Form, Modal, notification, Upload } from "antd";
import { RcFile } from "antd/lib/upload";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { updateBrandLogo } from "../../../../../Actions/RetailMatchActions";
import { beforeUploadFileCheck } from "../../../../../Logic/FileLogic";
import { IBrand } from "../../../../../Models/IBrand";
import { IRetailMatchJob } from "../../../../../Models/IRetailMatch";
import { IRetailMatchUpdateBrandLogoRequest } from "../../../../../Models/Requests/IRetailMatchUpdateBrandLogoRequest";
import { BodyText } from "../../../../Common/ReportStyles/Text";

interface IRetailMatchIntroEditBrandLogoProps {
  job: IRetailMatchJob;
  brand: IBrand;
  visible: boolean;
  setVisible: (show: boolean) => void;
}

const maxBrandLogoKB = 200;

const RetailMatchIntroEditBrandLogo = (
    props: IRetailMatchIntroEditBrandLogoProps
) => {
    const dispatch: Dispatch<any> = useDispatch();

    const [photoUploadList, setPhotoUploadList] = useState<any>([]);
    const [photosReadyForUpload, setPhotosReadyForUpload]
    = useState<boolean>(false);
    const [loadingUpdateJob, setLoadingUpdateJob] = useState<boolean>();

    const submitAddImageRequest = (): void => {
        setLoadingUpdateJob(true);
        const request: IRetailMatchUpdateBrandLogoRequest = {
            jobId: props.job.jobId,
            brandId: props.brand.brandId,
            image: photoUploadList[0],
        };

        dispatch(
            updateBrandLogo(request, () => {
                setLoadingUpdateJob(false);
                props.setVisible(false);
                setPhotoUploadList([]);
                setPhotosReadyForUpload(false);
            })
        );
    };

    const handleRemovePhoto = (file: RcFile): void => {
    //THE COMMENTED CODE HANDLES BULK UPLOADS

        // let currentList: RcFile[] = [...photoUploadList];
        // let fileIndex: number = currentList.indexOf(file);

        // currentList.splice(fileIndex, 1);

        // if (currentList.length < 1) {
        //     setPhotosReadyForUpload(false);
        // }

        // setPhotoUploadList(currentList);
        setPhotosReadyForUpload(false);
        setPhotoUploadList([]);
    };

    const handleBeforeUpload = (file: RcFile): boolean => {
    // let currentList: RcFile[] = [...photoUploadList, file];

        const maxBytes = 1024 * maxBrandLogoKB;

        if (file.size > maxBytes) {
            notification["error"]({
                message: <span style={{ color: "red" }}>File too large</span>,
                description: `Images must be ${maxBrandLogoKB} KB or smaller.`,
                onClick: () => {
                    notification.destroy();
                },
                duration: 0,
                style: { cursor: "pointer" },
            });
            return false;
        }

        if (beforeUploadFileCheck(file)) {
            setPhotoUploadList([file]);
            setPhotosReadyForUpload(true);

            return false;
        }

        return true;
    };

    return (
        <Modal
            title="Edit Brand Logo"
            visible={props.visible}
            centered={true}
            onCancel={() => props.setVisible(false)}
            footer={false}
        >
            <>
                <p>*Max file size: {maxBrandLogoKB} KB</p>
                <Form.Item label="Upload">
                    <Upload
                        name="logo"
                        listType="picture"
                        multiple={false}
                        fileList={photoUploadList}
                        beforeUpload={(file: RcFile) => handleBeforeUpload(file)}
                        onRemove={(file: RcFile) => handleRemovePhoto(file)}
                    >
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loadingUpdateJob}
                            disabled={photosReadyForUpload}
                        >
              Select a photo to upload.
                        </Button>
                    </Upload>
                    {photosReadyForUpload ? (
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loadingUpdateJob}
                            onClick={submitAddImageRequest}
                        >
              Click to upload
                        </Button>
                    ) : null}
                    <BodyText>Accepted file types: .jpg, .jpeg, .png.</BodyText>
                </Form.Item>
            </>
        </Modal>
    );
};

export default RetailMatchIntroEditBrandLogo;
